/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import { PlusIcon } from '../../../../../images/icons/Plus/Plus'

const NewVariation = (props: any) => (
    <div className="quote__form__dynamic--add variation__block variation__block--new" onClick={props.onClick}>
        <PlusIcon /><span>Add another quote</span><PlusIcon />
    </div>
)

export default  NewVariation



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/NewVariation.tsx